<template>
  <div class="categories aside-item">
    <div class="aside-item-title">{{ $t('Категории') }}</div>
    <div class="categories-list">
      <a class="categories-list-item" :href="siteUrl(category.slug)" v-for="category in categories" :key="category.slug">{{ $t(category.name) }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shop-categories',

  components: {},

  props: {
    categories: Array,
  },

  data() {
    return {};
  },

  methods: {}
};
</script>

<style scoped>
.categories-list {
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}

.categories-list-item {
  margin: 0 0 15px 0;
}

.categories-list-item:last-child {
  margin: 0;
}

.categories-list-item:hover {
  color: #3c91e6;
}

.categories-list-item:active {
  color: #29629c;
}
</style>
